module.exports = __webpack_public_path__ + "img/time-icon.4d90cc6f.svg";